import React from 'react';

export default class TransactionZapCashIcon extends React.Component {
  render() {
    return (
      <svg height="100%" viewBox="0 0 25.929 25.929">
        <path
          fill="#6FCBE9"
          d="M12.965,0C5.804,0,0,5.804,0,12.965c0,7.16,5.805,12.965,12.965,12.965c7.16,0,12.965-5.805,12.965-12.965
            C25.929,5.804,20.125,0,12.965,0z M18.796,18.808h-2.732v2.175c0,0.08-0.065,0.145-0.145,0.145h-1.904
            c-0.08,0-0.145-0.065-0.145-0.145v-2.175h-1.772v2.175c0,0.08-0.065,0.145-0.145,0.145h-1.904c-0.08,0-0.145-0.065-0.145-0.145
            v-2.175h-2.77c-0.046,0-0.089-0.039-0.109-0.08c-0.021-0.041-0.017-0.104,0.01-0.141l6.803-9.399H7.625
            c-0.068,0-0.126-0.044-0.126-0.112V7.153c0-0.068,0.059-0.116,0.126-0.116h2.279V4.946c0-0.08,0.065-0.145,0.145-0.145h1.904
            c0.08,0,0.145,0.065,0.145,0.145v2.091h1.772V4.946c0-0.08,0.065-0.145,0.145-0.145h1.904c0.08,0,0.145,0.065,0.145,0.145v2.091
            h2.103c0.046,0,0.089,0.021,0.109,0.063c0.021,0.041,0.017,0.086-0.01,0.124l-6.839,9.392h5.508c0.042,0,0.082,0.024,0.104,0.061
            c0.509,0.818,1.023,1.359,1.824,1.892c0.045,0.03,0.065,0.092,0.049,0.144C18.898,18.763,18.85,18.808,18.796,18.808z"
        />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/icons/TransactionZapCashIcon.js